import type { SUSPENSE as iSUSPENSE } from "./index.d"
export const SUSPENSE: iSUSPENSE = Symbol("SUSPENSE") as any
export type SUSPENSE = iSUSPENSE
